import logo from '../assets/nav-logo.svg';
import { useTranslation } from 'react-i18next';
import PillNav from './pillnav';
import './header.css';

const Header = () => {
  const { t } = useTranslation();

  const navItems = [
    { label: t('nav.home'), href: '#home' },
    { label: t('nav.events'), href: '#events' },
    { label: t('nav.how_it_works'), href: '#how-it-works' },
    { label: t('nav.featured'), href: '#featured' },
    { label: t('nav.booking'), href: '#booking' },
    { label: t('nav.community'), href: '#community' },
    { label: t('nav.newsletter'), href: '#newsletter' },
  ];

  return (
    <header className="site-header">
      <PillNav
        logo={logo}
        logoAlt={t('nav.logo_alt')}
        logoHref="#home"
        items={navItems}
        activeHref="#home"
        className="event-ticket-nav"
        ease="power2.easeOut"
        baseColor="var(--neon)"
        pillColor="var(--beige)"
        hoveredPillTextColor="var(--beige)"
        pillTextColor="var(--green)"
        activePillColor="var(--green)"
        activePillTextColor="var(--beige)"
        theme="color"
        initialLoadAnimation
      />
    </header>
  );
};

export default Header;
